let addWatermark = async (imageUrl) => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  const image = new Image();
  image.src = imageUrl;
  image.crossOrigin = "anonymous";

  return await new Promise(resolve => {
    image.onload = () => {
      // 缩小图片尺寸为原来的一半
      // const targetWidth = image.width / 2;
      // const targetHeight = image.height / 2;

      canvas.width = image.width;
      canvas.height = image.height;
      ctx.drawImage(image, 0, 0);

      const watermarkText1 = "昌恩智能";
      const watermarkText2 = "www.szce.com";
      const fontSize = calculateFontSize(canvas.height);

      ctx.font = `${fontSize}px 'Microsoft YaHei'`;
      // ctx.fillStyle = "#dbdbdb";
      ctx.fillStyle = "rgba(66,66,66, 0.2)";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      const rotationAngle = -6 * (Math.PI / 180);
      ctx.rotate(rotationAngle);

      // 垂直偏移值
      const yOffset = 70;
      // console.log(" canvas.width", canvas.width);
      // console.log(" canvas.height", canvas.height);

      if (canvas.width > 2820) {
        // 使用嵌套循环绘制水印
        for (let row = 0; row < 14; row++) {
          for (let col = 0; col < 5; col++) {
            ctx.font = "62px 'Microsoft YaHei'";
            const x = col * (canvas.width / 5) + canvas.width / 10;
            const y =
              row * (canvas.height / 14) + canvas.height / 24 + yOffset;
            ctx.fillText(watermarkText1, x, y);

            const x2 = col * (canvas.width / 5) + canvas.width / 10;
            const y2 =
              row * (canvas.height / 14) +
              (canvas.height / 24) * 1.6 +
              yOffset;
            ctx.fillText(watermarkText2, x2, y2);
          }
        }
      } else {
        // 使用嵌套循环绘制水印
        for (let row = 0; row < 16; row++) {
          for (let col = 0; col < 4; col++) {
            const x = col * (canvas.width / 4) + canvas.width / 10;
            const y =
              row * (canvas.height / 16) + canvas.height / 24 + yOffset;
            ctx.fillText(watermarkText1, x, y);

            const x2 = col * (canvas.width / 4) + canvas.width / 10;
            const y2 =
              row * (canvas.height / 16) +
              (canvas.height / 24) * 1.5 +
              yOffset;
            ctx.fillText(watermarkText2, x2, y2);
          }
        }
      }

      // 恢复Canvas的旋转状态
      ctx.rotate(-rotationAngle);

      const watermarkedImageUrl = canvas.toDataURL("image/jpeg", 0.99);
      // this.watermarkedImages = watermarkedImageUrl;
      resolve(watermarkedImageUrl);
    };
  });
}

function calculateFontSize(canvasHeight) {
  // 根据 canvas 的高度动态计算字体大小
  return Math.floor(canvasHeight / 64);
}


export async function addWatermarkToData(data, vm) {
  let num = data.length
  vm.watermarkedImageList = [];
  for (const item of data) {
    const imageUrl = item.imgPath;
    // console.log('图片路径传入',imageUrl);
    let watermarkedImageUrl
    if (imageUrl) {
      watermarkedImageUrl = await addWatermark(imageUrl); // 使用水印方法
    }
    // const watermarkedImageUrl = await addWatermark(imageUrl); // 使用水印方法
    const watermarkedData = {
      imgPath:  watermarkedImageUrl,
      // imgPath: watermarkedImageUrl ,
      resourceId: item.resourceId,
      title: item.title,
      sort: item.sort
    };
    console.log("watermarkedData", watermarkedData);
    vm.watermarkedImageList.push(watermarkedData);
    num--
  }
  if (num <= 0) {
    console.log('数据加载完成');
    vm.isLoading = true;
  }
  return vm.watermarkedImageList;
};





// WEBPACK FOOTER //
// ./src/utils/watermarkAddition.js